module.exports = __webpack_public_path__ + "img/night.7871e604.jpg";